import * as React  from 'react';
import '../../inCss/Progress.css';

export interface ProgressProps {
    progressText: string;
}

export const Card: React.StatelessComponent<ProgressProps> = (props) => {

    return (        
        <div className="card text-center progress-center">
            <div className="card-body">
                <div className="loading-spinner"/>
                <p>&nbsp;</p>
                <div className="progress-text">{props.progressText}</div>
            </div>
        </div>
    );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/cards/ProgressCard.tsx